/** SorakaPainter — 2D star support silhouette. */
export const SorakaPainter = {
  paint(ctx, _pos, radius, _entity) {
    ctx.beginPath();
    ctx.arc(0, 0, radius * 0.85, 0, Math.PI * 2);
    ctx.fillStyle = '#4c1d95';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(0, -radius * 0.55, radius * 0.38, 0, Math.PI * 2);
    ctx.fillStyle = '#f9a8d4';
    ctx.fill();

    ctx.fillStyle = '#e9d5ff';
    ctx.fillRect(radius * 0.5, -radius * 0.7, radius * 0.12, radius * 1.15);

    ctx.beginPath();
    ctx.arc(radius * 0.56, -radius * 0.9, radius * 0.18, 0, Math.PI * 2);
    ctx.fillStyle = '#fce7f3';
    ctx.fill();
  }
};
